export type StaffRole = "Yönetici" | "Danışma" | "Personel";
export type CompensationType = "maaş" | "prim" | "maaş+prim";

export interface StaffMember {
  id: string;
  fullName: string;
  phone: string;
  specialty: string;
  role: StaffRole;
  active: boolean;
  salary: number;
  advance: number;
  leaveDays: number;
  overtimeHours: number;
  joinDate: string;
  leaveDate: string;
  email: string;
  address: string;
  notes: string;
  takesAppointments: boolean;
  compensationType: CompensationType;
}

export interface StaffTransaction {
  id: string;
  staffId: string;
  type: "debit" | "credit";
  title: string;
  amount: number;
  date: string;
  method: "nakit" | "havale" | "avans" | "hakediş";
  description?: string;
}

export interface StaffCommission {
  id: string;
  staffId: string;
  serviceName: string;
  commissionAmount: number;
  date: string;
  status: "Bekliyor" | "Onaylandı" | "Ödendi";
  approvedBy: string;
  approvedAt: string;
  paidAt: string;
}

export const staffMembersData: StaffMember[] = [
  {
    id: "stf-001",
    fullName: "Ayşe Korkmaz",
    phone: "+90 532 111 2233",
    specialty: "Masaj Uzmanı, Manikür",
    role: "Personel",
    active: true,
    salary: 18500,
    advance: 0,
    leaveDays: 2,
    overtimeHours: 12,
    joinDate: "2023-03-15",
    leaveDate: "",
    email: "ayse.korkmaz@kuguspa.com",
    address: "Kadıköy, İstanbul",
    notes: "Özellikle sıcak taş masajında çok talep görüyor.",
    takesAppointments: true,
    compensationType: "maaş+prim",
  },
  {
    id: "stf-002",
    fullName: "Mehmet Sarı",
    phone: "+90 533 222 3344",
    specialty: "Spa Terapisti, Detoks",
    role: "Personel",
    active: true,
    salary: 21000,
    advance: 1500,
    leaveDays: 0,
    overtimeHours: 8,
    joinDate: "2022-08-01",
    leaveDate: "",
    email: "mehmet.sari@kuguspa.com",
    address: "Beşiktaş, İstanbul",
    notes: "SPA paket satışlarında birinci sırada.",
    takesAppointments: true,
    compensationType: "maaş+prim",
  },
  {
    id: "stf-003",
    fullName: "Zeynep Demirci",
    phone: "+90 534 333 4455",
    specialty: "Cilt Bakımı, Aromaterapi",
    role: "Personel",
    active: true,
    salary: 19500,
    advance: 0,
    leaveDays: 1,
    overtimeHours: 6,
    joinDate: "2023-06-10",
    leaveDate: "",
    email: "zeynep.demirci@kuguspa.com",
    address: "Ataşehir, İstanbul",
    notes: "Anti-aging cilt bakımında uzmanlaştı.",
    takesAppointments: true,
    compensationType: "maaş",
  },
  {
    id: "stf-004",
    fullName: "Burak Tan",
    phone: "+90 535 444 5566",
    specialty: "Sporcu Masajı, Medikal",
    role: "Personel",
    active: true,
    salary: 20000,
    advance: 2000,
    leaveDays: 0,
    overtimeHours: 10,
    joinDate: "2022-11-20",
    leaveDate: "",
    email: "burak.tan@kuguspa.com",
    address: "Şişli, İstanbul",
    notes: "Erkek müşteriler arasında çok popüler.",
    takesAppointments: true,
    compensationType: "prim",
  },
  {
    id: "stf-005",
    fullName: "Elif Yılmaz",
    phone: "+90 536 555 6677",
    specialty: "Pedikür, Manikür, Sauna",
    role: "Personel",
    active: true,
    salary: 17000,
    advance: 0,
    leaveDays: 3,
    overtimeHours: 4,
    joinDate: "2024-01-15",
    leaveDate: "",
    email: "elif.yilmaz@kuguspa.com",
    address: "Üsküdar, İstanbul",
    notes: "Jel tırnak uygulamalarında uzman.",
    takesAppointments: true,
    compensationType: "maaş+prim",
  },
  {
    id: "stf-006",
    fullName: "Seda Avcı",
    phone: "+90 537 666 7788",
    specialty: "Danışma, Randevu Yönetimi",
    role: "Danışma",
    active: true,
    salary: 22000,
    advance: 0,
    leaveDays: 0,
    overtimeHours: 0,
    joinDate: "2023-09-01",
    leaveDate: "",
    email: "seda.avci@kuguspa.com",
    address: "Maltepe, İstanbul",
    notes: "Müşteri ilişkileri ve randevu yönetiminden sorumlu.",
    takesAppointments: false,
    compensationType: "maaş",
  },
  {
    id: "stf-007",
    fullName: "Ali Yıldırım",
    phone: "+90 538 777 8899",
    specialty: "Genel Yönetim, Raporlama",
    role: "Yönetici",
    active: true,
    salary: 45000,
    advance: 0,
    leaveDays: 0,
    overtimeHours: 0,
    joinDate: "2021-05-01",
    leaveDate: "",
    email: "ali.yildirim@kuguspa.com",
    address: "Etiler, İstanbul",
    notes: "İşletme sahibi ve genel müdür.",
    takesAppointments: false,
    compensationType: "maaş",
  },
];

export const staffTransactions: StaffTransaction[] = [
  // Bugün (2026-05-09) - Ayşe Korkmaz
  { id: "trn-today-01", staffId: "stf-001", type: "debit", title: "Detoks Vücut Bakımı", amount: 160, date: "2026-05-09", method: "hakediş", description: "Bugünkü randevu prim hakedişi" },
  { id: "trn-today-02", staffId: "stf-001", type: "debit", title: "Klasik Masaj (60 dk)", amount: 120, date: "2026-05-09", method: "hakediş", description: "Bugünkü randevu prim hakedişi" },
  // Bugün (2026-05-09) - Mehmet Sarı
  { id: "trn-today-03", staffId: "stf-002", type: "debit", title: "Anti-Aging Cilt Bakımı", amount: 250, date: "2026-05-09", method: "hakediş", description: "Bugünkü randevu prim hakedişi" },
  // Bugün (2026-05-09) - Burak Tan
  { id: "trn-today-04", staffId: "stf-004", type: "debit", title: "Sporcu Masajı", amount: 140, date: "2026-05-09", method: "hakediş", description: "Bugünkü randevu prim hakedişi" },
  // Bugün (2026-05-09) - Elif Yılmaz
  { id: "trn-today-05", staffId: "stf-005", type: "debit", title: "Jel Tırnak", amount: 80, date: "2026-05-09", method: "hakediş", description: "Bugünkü randevu prim hakedişi" },

  // Bu hafta (2026-05-05 ~ 2026-05-09) - Ekstra kayıtlar
  { id: "trn-week-01", staffId: "stf-003", type: "debit", title: "Anti-Aging Cilt Bakımı", amount: 200, date: "2026-05-07", method: "hakediş", description: "Bu hafta randevu prim hakedişi" },
  { id: "trn-week-02", staffId: "stf-005", type: "debit", title: "Manikür + Pedikür", amount: 110, date: "2026-05-07", method: "hakediş", description: "Bu hafta randevu prim hakedişi" },
  { id: "trn-week-03", staffId: "stf-001", type: "credit", title: "Prim Ödemesi", amount: 200, date: "2026-05-08", method: "nakit", description: "Gün sonu nakit prim ödemesi" },
  { id: "trn-week-04", staffId: "stf-002", type: "credit", title: "Havale Ödemesi", amount: 300, date: "2026-05-08", method: "havale", description: "Hafta sonu havale ödemesi" },

  // Ayşe Korkmaz - alacaklar (debit)
  { id: "trn-001", staffId: "stf-001", type: "debit", title: "Klasik Masaj (60 dk)", amount: 120, date: "2026-05-08", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-002", staffId: "stf-001", type: "debit", title: "Profesyonel Manikür", amount: 80, date: "2026-05-08", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-003", staffId: "stf-001", type: "debit", title: "Sıcak Taş Masajı (90 dk)", amount: 200, date: "2026-05-07", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-004", staffId: "stf-001", type: "debit", title: "Aromaterapi Masajı", amount: 150, date: "2026-05-05", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-005", staffId: "stf-001", type: "debit", title: "Detoks SPA Paketi", amount: 100, date: "2026-05-03", method: "hakediş", description: "Paket prim hakedişi" },
  { id: "trn-006", staffId: "stf-001", type: "debit", title: "Sporcu Masajı", amount: 90, date: "2026-05-02", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  // Ayşe Korkmaz - ödemeler (credit)
  { id: "trn-007", staffId: "stf-001", type: "credit", title: "Prim Ödemesi", amount: 400, date: "2026-05-07", method: "nakit", description: "Gün sonu nakit prim ödemesi" },
  { id: "trn-008", staffId: "stf-001", type: "credit", title: "Avans Ödemesi", amount: 300, date: "2026-05-01", method: "nakit", description: "Aylık avans ödemesi" },

  // Mehmet Sarı - alacaklar
  { id: "trn-009", staffId: "stf-002", type: "debit", title: "SPA Günü Paketi", amount: 350, date: "2026-05-08", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-010", staffId: "stf-002", type: "debit", title: "Detoks SPA Paketi", amount: 300, date: "2026-05-06", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-011", staffId: "stf-002", type: "debit", title: "Anti-Aging Cilt Bakımı", amount: 250, date: "2026-05-04", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-012", staffId: "stf-002", type: "debit", title: "Medikal Masaj", amount: 180, date: "2026-05-02", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  // Mehmet Sarı - ödemeler
  { id: "trn-013", staffId: "stf-002", type: "credit", title: "Prim Ödemesi", amount: 500, date: "2026-05-06", method: "havale", description: "Havale ile prim ödemesi" },
  { id: "trn-014", staffId: "stf-002", type: "credit", title: "Avans Ödemesi", amount: 1500, date: "2026-04-28", method: "nakit", description: "Aylık avans ödemesi" },

  // Zeynep Demirci - alacaklar
  { id: "trn-015", staffId: "stf-003", type: "debit", title: "Anti-Aging Cilt Bakımı", amount: 200, date: "2026-05-08", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-016", staffId: "stf-003", type: "debit", title: "Aromaterapi Masajı", amount: 150, date: "2026-05-05", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-017", staffId: "stf-003", type: "debit", title: "Klasik Masaj", amount: 120, date: "2026-05-03", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  // Zeynep Demirci - ödemeler
  { id: "trn-018", staffId: "stf-003", type: "credit", title: "Prim Ödemesi", amount: 200, date: "2026-05-05", method: "nakit", description: "Gün sonu prim ödemesi" },
  { id: "trn-019", staffId: "stf-003", type: "credit", title: "Maaş Ödemesi", amount: 19500, date: "2026-05-01", method: "havale", description: "Aylık maaş ödemesi" },

  // Burak Tan - alacaklar
  { id: "trn-020", staffId: "stf-004", type: "debit", title: "Sporcu Masajı", amount: 140, date: "2026-05-08", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-021", staffId: "stf-004", type: "debit", title: "Medikal Masaj", amount: 150, date: "2026-05-04", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-022", staffId: "stf-004", type: "debit", title: "SPA Günü Paketi", amount: 200, date: "2026-05-01", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  // Burak Tan - ödemeler
  { id: "trn-023", staffId: "stf-004", type: "credit", title: "Prim Ödemesi", amount: 100, date: "2026-05-01", method: "nakit", description: "Gün sonu prim ödemesi" },
  { id: "trn-024", staffId: "stf-004", type: "credit", title: "Avans Ödemesi", amount: 2000, date: "2026-04-25", method: "nakit", description: "Aylık avans ödemesi" },

  // Elif Yılmaz - alacaklar
  { id: "trn-025", staffId: "stf-005", type: "debit", title: "Profesyonel Pedikür", amount: 90, date: "2026-05-08", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-026", staffId: "stf-005", type: "debit", title: "Manikür + Pedikür", amount: 110, date: "2026-05-06", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  { id: "trn-027", staffId: "stf-005", type: "debit", title: "Jel Tırnak", amount: 80, date: "2026-05-03", method: "hakediş", description: "Randevu sonrası prim hakedişi" },
  // Elif Yılmaz - ödemeler
  { id: "trn-028", staffId: "stf-005", type: "credit", title: "Prim Ödemesi", amount: 150, date: "2026-05-03", method: "nakit", description: "Gün sonu prim ödemesi" },
];

// Keep staffCommissions for backward compat if needed
export const staffCommissions: StaffCommission[] = [
  {
    id: "com-001",
    staffId: "stf-001",
    serviceName: "Klasik Masaj (60 dk)",
    commissionAmount: 120,
    date: "2026-05-08",
    status: "Bekliyor",
    approvedBy: "",
    approvedAt: "",
    paidAt: "",
  },
  {
    id: "com-002",
    staffId: "stf-001",
    serviceName: "Profesyonel Manikür",
    commissionAmount: 80,
    date: "2026-05-08",
    status: "Onaylandı",
    approvedBy: "Ali Yıldırım",
    approvedAt: "2026-05-08",
    paidAt: "",
  },
  {
    id: "com-003",
    staffId: "stf-002",
    serviceName: "SPA Günü Paketi",
    commissionAmount: 350,
    date: "2026-05-08",
    status: "Ödendi",
    approvedBy: "Ali Yıldırım",
    approvedAt: "2026-05-08",
    paidAt: "2026-05-08",
  },
  {
    id: "com-004",
    staffId: "stf-003",
    serviceName: "Anti-Aging Cilt Bakımı",
    commissionAmount: 200,
    date: "2026-05-08",
    status: "Bekliyor",
    approvedBy: "",
    approvedAt: "",
    paidAt: "",
  },
  {
    id: "com-005",
    staffId: "stf-004",
    serviceName: "Sporcu Masajı",
    commissionAmount: 140,
    date: "2026-05-08",
    status: "Onaylandı",
    approvedBy: "Ali Yıldırım",
    approvedAt: "2026-05-08",
    paidAt: "",
  },
  {
    id: "com-006",
    staffId: "stf-005",
    serviceName: "Profesyonel Pedikür",
    commissionAmount: 90,
    date: "2026-05-08",
    status: "Bekliyor",
    approvedBy: "",
    approvedAt: "",
    paidAt: "",
  },
  {
    id: "com-007",
    staffId: "stf-001",
    serviceName: "Sıcak Taş Masajı (90 dk)",
    commissionAmount: 200,
    date: "2026-05-07",
    status: "Ödendi",
    approvedBy: "Ali Yıldırım",
    approvedAt: "2026-05-07",
    paidAt: "2026-05-07",
  },
  {
    id: "com-008",
    staffId: "stf-002",
    serviceName: "Detoks SPA Paketi",
    commissionAmount: 300,
    date: "2026-05-06",
    status: "Onaylandı",
    approvedBy: "Ali Yıldırım",
    approvedAt: "2026-05-06",
    paidAt: "",
  },
  {
    id: "com-009",
    staffId: "stf-003",
    serviceName: "Aromaterapi Masajı",
    commissionAmount: 150,
    date: "2026-05-05",
    status: "Ödendi",
    approvedBy: "Ali Yıldırım",
    approvedAt: "2026-05-05",
    paidAt: "2026-05-05",
  },
  {
    id: "com-010",
    staffId: "stf-004",
    serviceName: "Medikal Masaj",
    commissionAmount: 150,
    date: "2026-05-04",
    status: "Bekliyor",
    approvedBy: "",
    approvedAt: "",
    paidAt: "",
  },
];